module.exports = __webpack_public_path__ + "assets/img/1_690.5625d2eb.jpg";